import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  ConfirmationOptions,
  ConfirmationPart,
  ConfirmationTestIds,
  DEFAULT_CONFIRMATION_TEST_IDS,
} from './confirmation-dialog.models';

/**
 * The look of every confirmation: title, message, optional warning, Cancel and the action button. Used by
 * ConfirmationDialogComponent, and by dialogs that keep their own buttons' logic (configuration Restore).
 */
@Component({
  selector: 'app-confirmation-view',
  templateUrl: './confirmation-view.component.html',
  styleUrls: ['./confirmation-view.component.scss'],
  standalone: false,
})
export class ConfirmationViewComponent implements OnChanges {
  @Input({ required: true }) options: ConfirmationOptions;
  /** Shows progress and disables both buttons. */
  @Input() running = false;
  @Output() readonly cancelled = new EventEmitter<void>();
  @Output() readonly confirmed = new EventEmitter<void>();

  paragraphs: ConfirmationPart[][] = [];
  testIds: ConfirmationTestIds = DEFAULT_CONFIRMATION_TEST_IDS;

  ngOnChanges(): void {
    this.testIds = { ...DEFAULT_CONFIRMATION_TEST_IDS, ...this.options.testIds };
    const message = this.options.message;
    this.paragraphs = (typeof message === 'string' ? [message] : message).map((paragraph) =>
      (typeof paragraph === 'string' ? [paragraph] : paragraph).map((part): ConfirmationPart => {
        if (typeof part === 'string') {
          return { kind: 'text', text: part };
        }
        return 'strong' in part ? { kind: 'strong', text: part.strong } : { kind: 'badge', text: part.badge };
      })
    );
  }
}
